import React from 'react'
import './Headline.scss'

export default function Headline(props) {
    return(
        <div className='Headline'>
            {props.text}
        </div>
    )
}